import { render, staticRenderFns } from "./NInputrows.vue?vue&type=template&id=4231bcdd&"
import script from "./NInputrows.vue?vue&type=script&lang=js&"
export * from "./NInputrows.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports